export default "__VITE_ASSET__DN0c9x3v__"